import { useQuery } from '@tanstack/react-query';
import type { CarrierDto } from '@app/shared';
import { api } from '../../lib/api';

/** Carrier and plan lookups shared by Plan Config and Inventory screens. */

export const useCarriers = (enabled = true) =>
  useQuery({
    queryKey: ['carriers'],
    queryFn: () => api.get<{ data: CarrierDto[] }>('/carriers'),
    select: (r) => r.data,
    staleTime: 60_000,
    enabled,
  });

export interface PlanOption {
  id: string;
  name: string;
  code: number;
  priceCents: number;
}

export const usePlanOptions = (enabled = true) =>
  useQuery({
    queryKey: ['plans', 'options'],
    queryFn: () => api.get<{ data: PlanOption[] }>('/plans/options'),
    select: (r) => r.data,
    staleTime: 30_000,
    enabled,
  });
